//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Api from '~/services/api';
export default {
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      images: [],
      mimetypes: [
        'image/jpeg',
        'image/jpg',
        'image/png',
        'application/pdf',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      ],
      imageUploadFailed: false,
    };
  },
  methods: {
    removeImage(index) {
      this.images.splice(index, 1);
      this.$emit('save', {
        key: 'attachments',
        focusNext: false,
        value: {
          files: this.images,
          textValue: 'files',
        },
      });
    },
    async submitImageMessage() {
      const image = this.$refs.imageInput.files[0];
      if (!image) return;
      // console.log(image);
      try {
        const response = await Api.uploadImage(this, image);
        this.images.push({
          fullPath:
            this.$config.MEDIA_SERVICE_HTTP_URL + '/storage/' + response.path,
          // name: response.path.substring(response.path.lastIndexOf('/') + 1),
          name: image.name,
        });
        console.log('file uploaded', this.images);
        this.$emit('save', {
          key: 'attachments',
          focusNext: false,
          value: {
            files: this.images,
            textValue: 'files',
          },
        });
      } catch (error) {
        this.imageUploadFailed = true;
        console.log(error);
      }

      this.$refs.imageInput.value = '';
    },
  },
};
